import * as React from "react";
import { ProtectiveFunction } from "../models/ProtectiveFunction";
import { Project } from "../models/Project";
import { Area } from "../models/Area";

interface Props {
  project: Project;
  protectiveFunction: ProtectiveFunction;
  area: Area;
}

const GuiReportHeader = (props: Props) => {
  return (
    <table className="table table-condensed" style={{marginBottom: 0}}>
      <tbody>
        <tr>
          <th>Client:</th>
          <td>{props.area.clientId}</td>
          <th>Location:</th>
          <td>{props.area.location}</td>
        </tr>
        <tr>
          <th>Project ID:</th>
          <td>{props.protectiveFunction.projectKey}</td>
          <th>Project Name:</th>
          <td>{props.project.projName}</td>
        </tr>
        <tr>
          <th>Function ID:</th>
          <td>{props.protectiveFunction.softKey}</td>
          <th>Function Name:</th>
          <td>{props.protectiveFunction.softKeyDescription}</td>
        </tr>
      </tbody>
    </table>
  );
}

export default GuiReportHeader;
